import axios from "axios";
import { API_ENDPOINTS } from "./apiEndpoints";
import { mapApiDataToTravelPlanDetails } from "../utils/unregisterTravelPlanMapper";
import type { SelectedJourney } from "../types/FormTypes";

export interface TravelPlanDetails {
  ReferenceId: string;
  EditId: string;
  email: string;
  selectedJourney: SelectedJourney;
  selectedReturnJourney?: SelectedJourney;
}

export async function getTravelPlanDetailsAPI(
  referenceId: string,
  editId: string
): Promise<TravelPlanDetails> {
  try {
    const url = API_ENDPOINTS.getTravelDetails(referenceId, editId);
    const response = await axios.get(url);
    const mappedData = mapApiDataToTravelPlanDetails(response.data);

    mappedData.ReferenceId = referenceId;
    mappedData.EditId = editId;

    return mappedData;
  } catch (err) {
    console.error("[API] Fel vid hämtning av reseplan:", err);
    throw err;
  }
}
